import React from 'react';
import { fixMojibake } from '../../utils/text/fix-mojibake';
import { Icon } from '../../design-system/icons/Icon';
import { getIconForBenefit } from './utils/iconMapping';

export interface BenefitsListProps {
  benefits: string[];
  maxItems?: number;
  className?: string;
  itemClassName?: string;
  iconSize?: 'sm' | 'md' | 'lg';
}

/**
 * Component to display a list of job benefits with icons
 */
export const BenefitsList: React.FC<BenefitsListProps> = ({
  benefits,
  maxItems = 3,
  className = '',
  itemClassName = '',
  iconSize = 'md',
}) => {
  if (!benefits || benefits.length === 0) {
    return null;
  }

  const iconSizeClasses = {
    sm: 'h-3 w-3',
    md: 'h-4 w-4',
    lg: 'h-5 w-5',
  };

  const displayBenefits = benefits.slice(0, maxItems);

  return (
    <div className={`flex flex-col gap-1 justify-center min-w-0 ${className}`}>
      {displayBenefits.map((benefit, idx) => {
        const { name, variant } = getIconForBenefit(benefit);
        return (
          <span 
            key={idx} 
            className={`flex items-center gap-2 text-xs text-gray-500 dark:text-gray-400 font-normal min-w-0 ${itemClassName}`}
          >
            <Icon name={name} variant={variant} useMaskForColor className={`${iconSizeClasses[iconSize]} text-gray-400 dark:text-gray-500 flex-shrink-0`} />
            <span className="break-words">{fixMojibake(benefit)}</span>
          </span>
        );
      })}
    </div>
  );
};
